export default function Testimonials() {
  const testimonials = [
    {
      name: 'Matt A.',
      location: 'Yelp Review',
      rating: 5,
      text: 'This place is great! I\'ve only dealt with Harry and he certainly knows his stuff. I had a custom suit made here about five months ago, and it looks phenomenal so I went back for another. He gave me solid advice and honest opinions about the suit styles and how different cuts will look with my build. I will certainly be going back in the future for more suits and shirts.',
      image: 'https://public.readdy.ai/ai/img_res/ef706cfaf5c24d0723fd79ada8b5d23b.jpg'
    },
    {
      name: 'Nick G.',
      location: 'Yelp Review',
      rating: 5,
      text: 'This place is absolutely top notch. VERY professional. Superb quality. Harry and Mike are great. They always take the time to walk through the different styles and fabrics without any pressure. I have a number of custom suits from them and wouldn\'t go anywhere else. Each suit has come on time and has been phenomenal. I love how I look in their suits and other people compliment them constantly.',
      image: 'https://readdy.ai/api/search-image?query=successful%20executive%20wearing%20perfectly%20fitted%20charcoal%20gray%20custom%20suit%20with%20confident%20smile%20in%20bright%20contemporary%20office%20environment%20with%20clean%20aesthetic&width=400&height=400&seq=test2&orientation=squarish'
    },
    {
      name: 'David R.',
      location: 'Boston, MA',
      rating: 5,
      text: 'Outstanding service from start to finish. The house call was incredibly convenient, and the selection of fabrics was impressive. My custom suit fits perfectly and the quality is exceptional. Worth every penny.',
      image: 'https://readdy.ai/api/search-image?query=distinguished%20gentleman%20in%20premium%20custom%20tailored%20suit%20with%20sophisticated%20style%20standing%20in%20elegant%20setting%20with%20soft%20professional%20lighting%20and%20refined%20atmosphere&width=400&height=400&seq=test3&orientation=squarish'
    }
  ];

  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl sm:text-5xl font-bold text-gray-900 mb-4" style={{ fontFamily: 'Playfair Display, serif' }}>
            What Our <span className="text-[#C9A961]">Clients Say</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Hear from satisfied clients who experienced the <strong>British Custom Tailors difference</strong>
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <div 
              key={index}
              className="bg-gray-50 rounded-2xl p-8 hover:shadow-2xl transition-all duration-300 border border-gray-100"
            >
              {/* Rating */}
              <div className="flex items-center mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-[#C9A961] text-xl"></i>
                ))}
              </div>

              {/* Testimonial Text */}
              <p className="text-gray-700 mb-6 leading-relaxed italic">
                "{testimonial.text}"
              </p>

              {/* Client Info */}
              <div className="flex items-center space-x-4">
                <div className="w-12 h-12 rounded-full overflow-hidden bg-gray-200">
                  <img 
                    src={testimonial.image}
                    alt={testimonial.name}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div>
                  <div className="font-bold text-gray-900">{testimonial.name}</div>
                  <div className="text-sm text-gray-600">{testimonial.location}</div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Trust Indicators */}
        <div className="mt-16 text-center">
          <div className="inline-flex items-center space-x-8 bg-gray-50 rounded-full px-8 py-4">
            <div className="flex items-center space-x-2">
              <i className="ri-star-fill text-[#C9A961] text-2xl"></i>
              <span className="text-2xl font-bold text-gray-900">5.0</span>
            </div>
            <div className="text-gray-600">
              <div className="font-semibold">127+ Reviews</div>
              <div className="text-sm">Verified Clients</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}